import { type PropsWithChildren } from 'react';

import type { ThresholdData } from '../../core/types/thresholds.js';

/**
 * Props for the CategoricalBarChart.ThresholdIndicator slot component
 * @public
 */
export interface CategoricalBarChartThresholdIndicatorProps {
  /** The threshold data to be graphed by the component */
  data: ThresholdData;
  /** The unique color picked in HEX, RGB, Color Token or HSL.*/
  color: string;
  /** Whereas to show the ranges filled or only the strokes */
  strokeOnly?: boolean;
  /**
   * Label to be shown in the threshold tooltip.
   * @defaultValue "Threshold"
   */
  label?: string;
}

/**
 * ThresholdIndicator slot for CategoricalBarChart
 * @public
 */
export const ThresholdIndicator = (
  props: PropsWithChildren<CategoricalBarChartThresholdIndicatorProps>,
) => null;

ThresholdIndicator['displayName'] = 'CategoricalBarChart.ThresholdIndicator';
